/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconRobot = StyledIconInline.extend`
  height: ${props => props.height || '25px'};
  width: ${props => props.width || '24px'};
`;

export const IconRobot = (props) => (
    <StyledIconRobot {...props}>
        <svg viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round"
               strokeLinejoin="round">
                <g transform="translate(0.000000, 1.000000)">
                    <path d="M16.5,8.3842 L7.5,8.3842 C6.948,8.3842 6.5,7.9362 6.5,7.3842 L6.5,1.3842 C6.5,0.8322 6.948,
                0.3842 7.5,0.3842 L16.5,0.3842 C17.052,0.3842 17.5,0.8322 17.5,1.3842 L17.5,7.3842 C17.5,7.9362 17.052,
                8.3842 16.5,8.3842 Z"/>
                    <path d="M10.5,3.3842 C10.5,3.9362 10.052,4.3842 9.5,4.3842 C8.948,4.3842 8.5,3.9362 8.5,
                    3.3842 C8.5,2.8322 8.948,2.3842 9.5,2.3842 C10.052,2.3842 10.5,2.8322 10.5,3.3842 Z"/>
                    <path d="M15.5,3.3842 C15.5,3.9362 15.052,4.3842 14.5,4.3842 C13.948,4.3842 13.5,3.9362 13.5,
                3.3842 C13.5,2.8322 13.948,2.3842 14.5,2.3842 C15.052,2.3842 15.5,2.8322 15.5,3.3842 Z"/>
                    <path d="M17.5,17.3838 L6.5,17.3838 C5.948,17.3838 5.5,16.9368 5.5,16.3838 L5.5,11.3838 C5.5,
                10.8318 5.948,10.3838 6.5,10.3838 L17.5,10.3838 C18.052,10.3838 18.5,10.8318 18.5,11.3838 L18.5,
                16.3838 C18.5,16.9368 18.052,17.3838 17.5,17.3838 Z"/>
                    <polygon points="10.5 10.384 13.5 10.384 13.5 8.384 10.5 8.384"/>
                    <path d="M10.5,6.3842 L13.5,6.3842"/>
                    <path d="M10.5,23.3838 L6.5,23.3838 L6.5,22.3838 C6.5,21.8318 6.948,21.3838 7.5,21.3838 L9.5,
                21.3838 C10.052,21.3838 10.5,21.8318 10.5,22.3838 L10.5,23.3838 Z"/>
                    <path d="M17.5,23.3838 L13.5,23.3838 L13.5,22.3838 C13.5,21.8318 13.948,21.3838 14.5,21.3838 L16.5,
                21.3838 C17.052,21.3838 17.5,21.8318 17.5,22.3838 L17.5,23.3838 Z"/>
                    <path d="M8.4766,21.3838 L8.4766,17.3838"/>
                    <path d="M15.5,21.3838 L15.5,17.3838"/>
                    <path d="M1.5,7.3842 L1.5,7.3842 C0.948,7.3842 0.5,6.9362 0.5,6.3842 L0.5,5.3842 L2.5,5.3842 L2.5,
                6.3842 C2.5,6.9362 2.052,7.3842 1.5,7.3842 Z"/>
                    <path d="M1.5,7.3842 L1.5,10.3842 C1.5,11.4882 2.396,12.3842 3.5,12.3842 L5.5,12.3842"/>
                    <path d="M22.5,17.3838 L22.5,17.3838 C23.052,17.3838 23.5,17.8318 23.5,18.3838 L23.5,19.3838 L21.5,
                19.3838 L21.5,18.3838 C21.5,17.8318 21.948,17.3838 22.5,17.3838 Z"/>
                    <path d="M22.5,17.3838 L22.5,14.3838 C22.5,13.2798 21.604,12.3838 20.5,12.3838 L18.5,12.3838"/>
                    <polygon points="4.5 5.384 6.5 5.384 6.5 3.384 4.5 3.384"/>
                    <polygon points="17.5 5.384 19.5 5.384 19.5 3.384 17.5 3.384"/>
                    <polygon points="10.5 15.384 13.5 15.384 13.5 12.384 10.5 12.384"/>
                    <path d="M15.5,12.3842 L15.5,15.3842" strokeDasharray="0.1,1.9"/>
                    <path d="M8.5,12.3842 L8.5,15.3842" strokeDasharray="0.1,1.9"/>
                </g>
            </g>
        </svg>
    </StyledIconRobot>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconRobot/index.js